import { useQuery } from '@tanstack/react-query';
import apiClient from '../../lib/api';

/**
 * グラフ表示用の健康データを取得するカスタムフック
 * @param patientId 患者ID
 * @param startDate 開始日 (YYYY-MM-DD形式)
 * @param endDate 終了日 (YYYY-MM-DD形式)
 * @param types データタイプ（オプション）
 * @returns React Query の結果
 */
export const useHealthData = (
  patientId: number | null,
  startDate: string,
  endDate: string,
  types?: string[]
) => {
  return useQuery({
    queryKey: ['healthData', patientId, startDate, endDate, types],
    queryFn: async () => {
      if (!patientId) {
        throw new Error('Patient ID is required');
      }
      return await apiClient.getHealthData(patientId, startDate, endDate, types);
    },
    // 患者IDと日付がnullまたは空でない場合のみ実行
    enabled:
      patientId !== null && !!startDate && !!endDate && !!apiClient.getIdToken(),
    // データを5分間キャッシュ
    staleTime: 5 * 60 * 1000,
    // エラー時のリトライ設定
    retry: 2,
    retryOnMount: false,
  });
};

export default useHealthData;
